import React, { useEffect } from 'react';
import lottie from 'lottie-web';
import { BackgroundContainer, Logo } from './styled';
const types = {
  default: '/spinner-animation.json',
  ach: '/ach-loader-animation.json',
};

function Loader({
  show, style, type = 'default',
}) {
  const height =
    typeof window !== 'undefined' ? window.innerHeight + 'px' : '100vh';

  useEffect(() => {
    lottie.searchAnimations();
  }, [show]);
  return (
    <BackgroundContainer style={{ ...style }} data-cy="loader" height={height} show={show}>
      <Logo className="lottie" data-anim-type="svg" data-anim-loop="true" data-animation-path={types[type] || types.default} data-name="loader"></Logo>
    </BackgroundContainer>
  );
}

export default Loader;
